import { SERVICES } from 'src/config/constants'
import { Loader } from 'src/utils/loader'

class ManagementLoader extends Loader {}

export const managementLoader = new ManagementLoader({
  service: SERVICES.mgmt
})
